import { createAxiosInstance } from "@/common/axiosInstance";
var BASE_PATH = 'erpnext_v1';
var erpFetcher = function erpFetcher() {
  var axiosInstance2 = createAxiosInstance(null, BASE_PATH, true);
  return axiosInstance2;
};
export default erpFetcher;